import React, { useState } from 'react';
import { Button } from '@cp/ds/src/components/button';
import { Stack } from '@cp/ds/src/components/stack';
import { Typography } from '@cp/ds/src/components/typography';
import { ModalView } from '@cp/ds/src/components/modalView';
import { FormField } from '@cp/ds/src/components/form';
import { FormFieldName } from 'src/entities/catalog/nav/resume/model/form';
import { SORTING_ITEMS } from 'src/entities/catalog/nav/resume';
import Sort from 'src/assets/shapes/sort.svg';

export const SortButton = ({ mobile }: { mobile?: boolean }) => {
  const [bannerOpen, setOpen] = useState(false);

  const SORTING_ITEMS_NEW = SORTING_ITEMS.map((item, index) => ({
    ...item,
    label:
      index === 0 ? (
        <Typography variant={'body bold'}>По умолчанию</Typography>
      ) : (
        <Typography variant={'body bold'}>{item.label}</Typography>
      ),
  }));

  return (
    <>
      <Button onClick={() => setOpen(true)} variant="text">
        <Stack alignItems="center" direction="row" sx={{ width: '100%', gap: 0.5 }}>
          <Sort />
          <Typography variant="caption">Сортировка</Typography>
        </Stack>
      </Button>
      <ModalView
        config={{ mobile: 'drawerBottom', desktop: 'dialog' }}
        isOpen={bannerOpen}
        onClose={() => setOpen(false)}
        scrollableContainerSx={{ pt: '40px', backgroundColor: 'white' }}
      >
        <Stack gap={2} sx={{ py: 1, borderRadius: '16px', alignItems: 'stretch', textAlign: 'start' }}>
          {mobile && (
            <Typography sx={{ textAlign: 'center' }} variant="h5">
              Сортировка
            </Typography>
          )}
          <FormField
            callback={() => setOpen(false)}
            itemSx={{ width: '100%', textAlign: 'start' }}
            items={SORTING_ITEMS_NEW}
            multiple={false}
            name={FormFieldName.Sorters}
            sorters
            type="checkboxGroup"
          />
        </Stack>
      </ModalView>
    </>
  );
};
